define('plugin/membership/view/MembershipModuleItemView',['require','plugin/membership/view/MembershipItemView'],function (require) {

    var MembershipItemView = require('plugin/membership/view/MembershipItemView');

    /**
     * Membership module item view
     *
     * @class MembershipModuleItemView
     */
    return MembershipItemView.extend({

        template: '#membership_module_item_view'

    });

});
